import { db } from './firestore'
import { collection } from 'firebase/firestore'

export const database = db

export const galleryRef = collection(db, 'gallery')
export const eventsRef = collection(db, 'events')
export const reservationsRef = collection(db, 'reservations')
